<template>
  <td>
    <!-- <button class="k-primary k-button k-grid-edit-command" @click="editHandler">Edit</button>
    <button class="k-button k-grid-remove-command" @click="confirmDelete">Remove</button> -->

    <span class="action-icon nt-edit" @click="editHandler"></span>
    <span class="action-icon nt-trash-fill" @click="confirmDelete"></span>
    <notifications group="foo" />
    <DialogBox
    ref="removeTenantDtl"
    @OkMethod="OkMethod"
    @closed="closeDialog"
    ></DialogBox>
  </td>
</template>

<script>
import Vue from "vue";
import Notifications from "vue-notification";
import DialogBox from "@/components/DialogBox.vue";
Vue.use(Notifications);

export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  components: {
    DialogBox
  },
  methods: {
    confirmDelete() {
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      this.removeHandler();
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    removeHandler: function() {
      if (this.$store.dispatch("packageModules/deleteModule", this.item.id)) {
        this.$notify({
          group: "foo",
          title: "Important message",
          text: "Module deleted csuccesfully!"
        });
      } else {
        this.$notify({
          group: "foo",
          title: "Important message",
          text: "Unable to delete module!"
        });
      }
      this.$store.dispatch("packageModules/getPackages");
    },
    editHandler: function() {
      this.$store.dispatch("packageModules/editModule", this.item);
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>




 
<style>
</style>
